export const contractTypeOptions = [
    { value: 'todos', title: 'Todos' },
    { value: 'residencial', title: 'Residencial' },
    { value: 'comercial', title: 'Comercial' }
  ];